import React, { useState, useEffect } from "react";
import axios from "axios";
import "./styles.css";
import Jumbotron from "react-bootstrap/Jumbotron";
import Container from "react-bootstrap/Container";
import CardColumns from "react-bootstrap/CardColumns";
import pokeball from "./components/pokeball.png";

import DropdownCard from "./components/DropdownCard";
import PokemonCard from "./components/PokemonCard";

export default function App() {
  const [selectedPokemon, selectPokemon] = useState();

  const updatePokemon = (val) => {
    axios
      .get(val)
      .then((res) => {
        const pokemon = res.data;
        selectPokemon(pokemon);
      })
      .catch(console.log);
  };

  // fetchPokemon(apiURL);

  useEffect(() => {
    updatePokemon("https://pokeapi.co/api/v2/pokemon/bulbasaur");
  }, []);

  const handleChange = (event) => {
    const inputVal = event.target.value;
    const newURL = "https://pokeapi.co/api/v2/pokemon/" + inputVal;
    updatePokemon(newURL);
  };

  return (
    <div className="App">
      <Container>
        <Jumbotron>
          <h1>
            <img src={pokeball} className="headingIcon" alt="Pokémon Browser" />{" "}
            Pokémon Browser{" "}
            <img src={pokeball} className="headingIcon" alt="Pokémon Browser" />
          </h1>
          <h3>
            Created with{" "}
            <a
              href="https://pokeapi.co/"
              target="_blank"
              rel="noopener noreferrer"
            >
              PokéAPI
            </a>
          </h3>
          <p>
            Demo project to show proficiency with RESTful APIs. See source code
            at{" "}
            <a
              href="https://codesandbox.io/s/objective-wiles-8tonr"
              target="_blank"
              rel="noopener noreferrer"
            >
              CodeSandbox.
            </a>
          </p>
          <PokemonCard pokemon={selectedPokemon} />
        </Jumbotron>
      </Container>
      <Container>
        <h3>Select a Pokémon</h3>
        <p>
          <strong>Note:</strong> PokéAPI's information on Generation VIII is
          unavailable at this time
        </p>
        <CardColumns>
          <DropdownCard
            title="Generation I"
            description="Pokémon introduced in Red, Blue, and Yellow Versions"
            range={[0, 151]}
            onChange={handleChange}
          />
          <DropdownCard
            title="Generation II"
            description="Pokémon introduced in Gold, Silver, and Crystal Versions"
            range={[151, 100]}
            onChange={handleChange}
          />
          <DropdownCard
            title="Generation III"
            description="Pokémon introduced in Ruby, Sapphire, and Emerald Versions"
            range={[251, 135]}
            onChange={handleChange}
          />
          <DropdownCard
            title="Generation IV"
            description="Pokémon introduced in Diamond, Pearl, and Platinum Versions"
            range={[386, 107]}
            onChange={handleChange}
          />
          <DropdownCard
            title="Generation V"
            description="Pokémon introduced in Black and White Versions"
            range={[493, 156]}
            onChange={handleChange}
          />
          <DropdownCard
            title="Generation VI"
            description="Pokémon introduced in X and Y Versions"
            range={[649, 72]}
            onChange={handleChange}
          />
          <DropdownCard
            title="Generation VII"
            description="Pokémon introduced in Sun and Moon Versions"
            range={[721, 86]}
            onChange={handleChange}
          />
          {/* <DropdownCard
            title="Generation VIII"
            description="Pokémon introduced in Sword and Shield Versions"
            range={[807, 87]}
            onChange={handleChange}
          /> */}
        </CardColumns>
      </Container>
      <footer>
        Created by{" "}
        <a
          href="http://patrickvhessman.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Patrick Hessman
        </a>{" "}
        | Pokéball icons by{" "}
        <a
          href="https://icons8.com/icon/p46YU389qlPN/open-pokeball"
          target="_blank"
          rel="noopener noreferrer"
        >
          Icons8
        </a>
      </footer>
    </div>
  );
}
